import Api from "../../../services/Api";
import { sanitizePathParam, sanitizeSerialPathParam } from "../../../lib/utils/apiValidation";

/**
 * SECURITY FIX H-6: Added input validation to prevent path traversal
 */
function fetchChargerConfig(siteId, chargerId) {
  const safeSiteId = sanitizePathParam(siteId, {
    pattern: /^[A-Za-z0-9_-]{1,64}$/,
    label: "site ID",
  });
  const safeChargerId = sanitizePathParam(chargerId, {
    pattern: /^[A-Za-z0-9_-]{1,64}$/,
    label: "charger ID",
  });
  return Api.get(`/service/iqevse-csms/charger/v1/config/${safeSiteId}/${safeChargerId}`);
}

/**
 * SECURITY FIX H-6: Payload sanitized by Api.js sanitizeRequestData()
 * Server MUST validate command permissions and parameters
 */
function sendOcppCommand(payload) {
  return Api.post(`/service/iqevse-csms/command/v1/send`, payload);
}

/**
 * SECURITY FIX H-6: Added input validation for physical device control
 * CRITICAL: Controls physical EV charger - server MUST validate permissions
 */
function startCharging(siteId, chargerSerial, chargingLevel) {
  const safeSiteId = sanitizePathParam(siteId, {
    pattern: /^[A-Za-z0-9_-]{1,64}$/,
    label: "site ID",
  });
  const safeSerial = sanitizeSerialPathParam(chargerSerial);
  const safeLevel = Number(chargingLevel);

  if (!Number.isInteger(safeLevel) || safeLevel < 0 || safeLevel > 100) {
    throw new Error("Invalid charging level: must be 0-100");
  }

  return Api.post(`/service/iqevse-csms/command/start_charging/${safeSiteId}/${safeSerial}`, {
    chargingLevel: safeLevel,
  });
}

/**
 * SECURITY FIX H-6: Added input validation for physical device control
 * CRITICAL: Controls physical EV charger - server MUST validate permissions
 */
function stopCharging(siteId, chargerSerial) {
  const safeSiteId = sanitizePathParam(siteId, {
    pattern: /^[A-Za-z0-9_-]{1,64}$/,
    label: "site ID",
  });
  const safeSerial = sanitizeSerialPathParam(chargerSerial);

  return Api.post(`/service/iqevse-csms/command/stop_charging/${safeSiteId}/${safeSerial}`);
}

function fetchStationHierarchy() {
  return Api.get("/service/iqevse-csms/stations/v1/hierarchy");
}

export { fetchChargerConfig, sendOcppCommand, startCharging, stopCharging, fetchStationHierarchy };
